import { call, select } from 'redux-saga/effects';
import {
  getPin as getPinBit,
  validatePin as validatePinBit,
} from '../bitSagas/pin';
import { actions as pinActions } from '../reducers/pin';

const apisNeedsStore = state => state.apiNeeds;

export function* getPin(input) {
  const reduxUpdate = {
    successUpdate: pinActions.getPinSuccess,
    errorUpdate: pinActions.getPinFail,
  };

  const getPinParams = {
    ...input,
    reduxUpdate,
  };

  let response = null;
  try {
    response = yield call(getPinBit, getPinParams);
  } catch (e) {
    return null;
  }

  return response;
}

export function* validatePin(input) {
  const reduxUpdate = {
    successUpdate: pinActions.validatePinSuccess,
    errorUpdate: pinActions.validatePinFail,
    errorInvalidUpdate: pinActions.validatePinInvalidPinFail,
    errorMaxRetriesUpdate: pinActions.validatePinMaxRetriesFail,
  };
  const apiNeeds = yield select(apisNeedsStore);

  const { cqId } = apiNeeds;

  const validatePinParams = {
    ...input,
    cqId,
    reduxUpdate,
  };

  let response = null;
  try {
    response = yield call(validatePinBit, validatePinParams);
  } catch (e) {
    return null;
  }

  return response;
}
